/**
 * @author Ariel
 * @date 2020-08-07
 * @description 报名管理--新增编辑第2步：计划安排信息
 */
import React from "react"
import {connect} from "dva"
import {framework_tool, component_tool, utils_tool} from "../../../../tool"
import {WizTableForm} from "../../../common"
import createColumn from './columns'
import moment from "moment";

import '../../../../styles/containers/workflow/apply/applyPlan/index.less'

let {WizContainer, modelUtils} = framework_tool
let {WizSpin, WizButton, WizTable, WizRow, WizCol, WizIcon, WizDivider, WizModal, WizForm, WizInput} = component_tool

class ApplyPlanDetail extends WizContainer {
  componentName = 'applyPlanDetail'

  constructor(props) {
    super(props)
    let pathname = '/workflow/apply'
    if (window.location.href.split("#")[1] && window.location.href.split("#")[1] .startsWith('/perm/applyPerm')) {
      pathname = '/perm/applyPerm'
    }
    this.pathname = pathname
    this.state = {
      applyId: props.applyId,
      type: props.type,
      planType: props.planType,
      applyInfo: [],
      showNormalVisible: false,//通用弹出框
      showEntityVisible: false,//其他有实体类型弹出框
      record: {},
      applyPlanFooter: props.applyPlanFooter,
    };
    this.planIds = []
  }


  _componentDidMount() {
    let {applyId} = this.state
    this._getApplyPlanInfo(applyId);
  }

  _getApplyPlanInfo(applyId) {
    this.doAction(
      {
        path: 'apply/getApplyInfo',
        payload: {
          key: 'getApplyInfo_' + applyId,
          apiParams: {id: applyId}
        }
      }
    )
  }

  _getClassById(id) {
    this.doAction(
      {
        path: 'classManagement/getClassById',
        payload: {
          key: 'classManagement@getClassById',
          apiParams: {id: id}
        }
      }
    )
  }

  _createPlans(values) {
    if (values && values.length && values.length > 0) {
      values && values.length && values.forEach(plan => {
        plan['startTime'] = moment(plan['startTime']).format("YYYY-MM-DD HH:mm:00")
        plan['endTime'] = moment(plan['endTime']).format("YYYY-MM-DD HH:mm:59")
      })
      this.doAction({
        path: 'apply/createApplyPlans',
        payload: {
          key: "createApplyPlans_" + this.state.applyId,
          apiParams: {applyId: this.state.applyId, plans: values}
        }
      })
    } else {
      wizNotice.error("计划安排不能为空");
    }
  }

  _updatePlans(values) {
    if (values && values.length && values.length > 0) {
      values && values.length && values.forEach(plan => {
        plan['startTime'] = moment(plan['startTime']).format("YYYY-MM-DD HH:mm:00")
        plan['endTime'] = moment(plan['endTime']).format("YYYY-MM-DD HH:mm:59")
      })
      this.doAction({
        path: 'apply/updateApplyPlans',
        payload: {
          key: "updateApplyPlans_" + this.state.applyId,
          apiParams: {applyId: this.state.applyId, plans: values}
        }
      })
    } else {
      wizNotice.error("计划安排不能为空");
    }
  }

  propsAndStateOnChange = {
    applyInfo: this._getApplyPlanListOver.bind(this),
    planList: this._getPlanListOver.bind(this),
    updatePlan: this._updatePlanOnChange.bind(this),
    createPlans: this._createPlansOnChange.bind(this),
    updatePlans: this._updatePlansOnChange.bind(this),
    enablePlan: this._enablePlanOnChange.bind(this),
    classInfo:  this._getClassInfoOver.bind(this),
    syncClassInfo: this._syncClassInfo.bind(this)
  }

  _syncClassInfo(nextProps, nextState) {
    if (nextProps.syncClassInfo.code === 1) {
      let plans = nextProps.syncClassInfo.data
      let {applyInfo} = nextState
      applyInfo.plans = plans
      this.setState({applyInfo: applyInfo, date: new Date()})
      wizNotice.success(nextProps.syncClassInfo['msg'])
      return true;
    } else {
      wizNotice.error(nextProps.syncClassInfo['msg'])
      return false;
    }
  }

  _getClassInfoOver(nextProps, nextState) {
    if (nextProps.classInfo.code === 1) {
      nextState.classInfoDetail = nextProps.classInfo.data
      return true;
    }
    return true;
  }

  _getPlanListOver(nextProps, nextState) {
    if (nextProps.planList.code === 1) {
      nextState.applyInfo = nextProps.planList.data
    }
    return true;
  }

  _getApplyPlanListOver(nextProps, nextState) {
    if (nextProps.applyInfo.code === 1) {
      nextState.applyInfo = nextProps.applyInfo.data
      this.record = nextState.applyInfo
    }
    return true;
  }

  _updatePlanOnChange(nextProps, nextState) {
    if (nextProps.updatePlan.code == 1) {
      let data = nextProps.updatePlan.data;
      let records = nextState.applyInfo.plans;
      for (let i = 0; i < records.length; i++) {
        if (records[i].id === data.id) {
          records[i] = data;
        }
      }
    }
    return true;
  }

  _createPlansOnChange(nextProps, nextState) {
    if (nextProps.createPlans.code === 1) {
      if (this.state.status === 1) {
        this.props.nextFunc && this.props.nextFunc()
      } else if (this.state.status === 2) {
        this.props.backFunc && this.props.backFunc()
      }
    }
    return true
  }

  _updatePlansOnChange(nextProps, nextState) {
    if (nextProps.updatePlans.code === 1) {
      if (this.state.status === 1) {
        this.props.nextFunc && this.props.nextFunc()
      } else if (this.state.status === 2) {
        this.props.backFunc && this.props.backFunc()
      }
    } else {
      wizNotice.error(nextProps.updatePlans.msg)
      return false;
    }
    return true
  }

  /**
   * 过滤字段值为undefined&null的字段
   * 处理数据格式
   * @param {Object} fieldsValue
   */
  fitterFieldsValue(fieldsValue) {
    let fitterValues = {};
    Object.keys(fieldsValue).forEach(key => {
      const value = fieldsValue[key];
      if (key === 'applyPlanTime' && value != null && value != undefined) {
        fitterValues['startTime'] = moment(value[0]).format("YYYY-MM-DD HH:mm:00")
        fitterValues['endTime'] = moment(value[1]).format("YYYY-MM-DD HH:mm:59")
      } else if (value != null && value != undefined) {
        fitterValues[key] = value;
      }
    });
    /**
     * 类型参数处理
     */
    fitterValues['type'] = this.state.planType
    return fitterValues;
  }

  _createApplyPlan() {
    let {planType} = this.state
    if (planType === 0) {
      this.setState({showNormalVisible: true})
    } else {
      this.setState({showEntityVisible: true})
    }
  }

  _syncUpdatePlan() {
    let {applyId} = this.state
    this.doAction(
      {
        path: 'apply/syncUpdatePlan',
        payload: {
          key: 'syncUpdatePlan',
          apiParams: {id: applyId}
        }
      }
    )
  }

  _updateRow(values) {
    let {planType,applyInfo} = this.state
    if(planType === 1 && values && values['entityId']) {
      let entityId = values && values['entityId']
      let planId = values && values['id']
      let applyNumber = -1;//已报名人数
      applyInfo && applyInfo.plans && applyInfo.plans.length && applyInfo.plans.some(plan => {
        if (plan.id === planId) {
          let reviewNumber = plan.reviewNumber == -1 ? 0 : plan.reviewNumber
          let passNumber = plan.passNumber == -1 ? 0 : plan.passNumber
          applyNumber = reviewNumber + passNumber
          this.setState({applyNumber:applyNumber})
          return true
        }
      })
      this._getClassById(entityId)
    }
    this.setState({showNormalVisible: true, record: values})
  }

  _removeRow(values) {
    if (this.state && this.state.applyInfo && this.state.applyInfo.plans && this.state.applyInfo.plans.length) {
      let newPlans = Object.assign([], this.state.applyInfo.plans);
      for (let i = 0; i < this.state.applyInfo.plans.length; i++) {
        if (this.state.applyInfo.plans[i] == values) {
          newPlans.splice(i, 1);
        }
      }
      this.state.applyInfo.plans = newPlans;
    }
    this.setState({date: new Date()})
  }

  _enablePlan(id, state) {
    this.doAction({
      path: "applyPlan/enablePlan",
      payload: {
        key: "enablePlan",
        apiParams: {id, state}
      }
    })
  }

  _enablePlanOnChange(nextProps, nextState) {
    if (nextProps.enablePlan.code === 1) {
      let {applyInfo} = nextState
      if (applyInfo && applyInfo.plans && applyInfo.plans.length && applyInfo.plans.length > 0) {
        applyInfo.plans.forEach(plan => {
          if (plan.id ===nextProps.enablePlan.data ) {
            plan.state === 0 ? plan.state=1 : plan.state = 0
          }
        })
      }
      wizNotice.success(nextProps.enablePlan['msg'])
      return true;
    } else {
      wizNotice.error(nextProps.enablePlan['msg'])
      return false;
    }
  }

  _changeRow = (values, nextRecordState) => {
    if (values && values.id) {
      this._enablePlan(values.id, nextRecordState)
    } else {
      values['state'] = nextRecordState
      this.setState({record: values,time: new Date().getTime()})
    }
  }

  _addPlanEntitySubmit = (type, values) => {
    let {showNormalVisible, showEntityVisible, applyInfo, planType} = this.state
    let plans = Object.assign([], applyInfo.plans);
    if (showNormalVisible) {
      let vars = this.fitterFieldsValue(values)
      if(planType === 0) {
        vars['entityId'] = 0
      }
      if (type === 'create') {
        vars['_id'] = new Date().getTime();
        plans = [...plans, vars];
      } else {
        if (vars['id'] ) {
          this.checkList('id', vars, plans)
        } else if (vars['entityId']) {
          this.checkList('entityId', vars, plans)
        } else {
          this.checkList('_id', vars, plans)
        }
      }
      applyInfo['plans'] = plans
      this.setState({showNormalVisible: false, record: {}})
    } else if (showEntityVisible) {
      if (values && values['valueRows']) {
        values['valueRows'].forEach(data => {
          if (data && data['id']) {
            let vars = {};
            vars['entityId'] = data['id']
            vars['name'] = data['name']
            vars['type'] = planType
            vars['startTime'] = data['startDate'] || data['startTime']
            vars['endTime'] = data['endDate'] || data['endTime']
            vars['address'] = data['address']
            vars['limitCount'] = data['limitNum'] || data['participateNum']
            vars['state'] = 1
            if (planType === 2){
              this.setState({showNormalVisible: true, itemData: vars})
            } else {
              this.checkList('entityId', vars, plans)
            }
          }
        })
      }
      applyInfo['plans'] = plans
      this.setState({showEntityVisible: false, record: {},})
    }
  }

  checkList = (checkKey = 'id', value = {}, list = []) => {
    let f = true;
    list && list.length && 1;
    for (let index = 0; index < list.length; index++) {
      let l = list[index];
      if (l[checkKey] === value[checkKey]) {
        list.splice(index, 1, {...l, ...value});
        f = false;
      }
    }
    if (f) {
      list.push(value)
    }
  }

  _buttonGroup = (record) => {
    let {planType} = this.state
    if (planType === 0 || planType === 1) {
      return (
        <>
          <a onClick={e => this._updateRow(record)}>编辑</a>
          <WizDivider type="vertical"/>
        </>
      )
    }
  }

  showNormalModal() {
    let {record, itemData,planType,classInfoDetail,applyNumber} = this.state
    let onSubmit = this._addPlanEntitySubmit.bind(this, record && (record['id'] || record['_id'] || record['entityId']) ? 'update' : 'create');
    let values = itemData || record
    let updateType = record && (record['id'] || record['_id'] || record['entityId']) ? 'update' : 'create'
    let limitNum = 0
    if(updateType === 'update' && classInfoDetail) {
      limitNum = classInfoDetail.limitNum
    }
    let formProps = {
      ref: 'form',
      columns: createColumn(this, values,planType,updateType,limitNum,applyNumber),
      onSubmit,
      record: null,
      preview: null,
      footer: undefined,
      formItemLayout: {
        labelCol: {span: 6},
        wrapperCol: {span: 15}
      }
    }
    return (
      <WizModal
        visible={this.state.showNormalVisible}
        destroyOnClose={true}
        footer={null}
        onCancel={() => this.setState({showNormalVisible: false, record: {}})}
      >
        <WizForm className={'form-inline'} {...formProps} />
      </WizModal>
    )
  }

  showEntityModal() {
    let {planType, showEntityVisible, applyInfo,applyId} = this.state
    let {plans} = applyInfo
    let planList = []
    let planModalType = 'checkbox'
    plans && plans.length && plans.forEach(d => {
      planList.push(d.entityId)
    })
    let entityDataConfig = WizTableForm.Config.classInfo(this, {apiParams: {status: 1,applyId:applyId}});
    if (planType === 1) {
      entityDataConfig = WizTableForm.Config.classInfo(this, {apiParams: {status: 1,applyId:applyId}});
    }
    // else if (planType === 2) {
    //   entityDataConfig = WizTableForm.Config.activity(this, {apiParams: {apply: 1, state: 1}});
    //   planModalType = 'radio'
    // }
    let tableFormProps = {
      title: '添加计划安排',
      showModal: true,
      showSelectValue: false,
      visible: showEntityVisible,
      selectType: planModalType,
      initRows: [],
      value: [],
      onSubmit: this._addPlanEntitySubmit.bind(this, ''),
      onCancel: () => this.setState({showEntityVisible: false}),
      searchProps: {
        dataFormat: (v) => {
          let value = Object.assign([], v)
          if (value['classDate'] && value['classDate'].length === 2) {
            value['startDate'] = moment(value['classDate'][0]).format("YYYY-MM-DD HH:mm:00")
            value['endDate'] = moment(value['classDate'][1]).format("YYYY-MM-DD HH:mm:59")
          }
          delete value['classDate']
          return value
        }
      },
      tableProps: {
        needOnRowSelect: (record, index) => {
          return !planList.includes(record.id)
        },
        rowSelection: {
          getCheckboxProps: (record) => {
            return {disabled: planList.includes(record.id)}
          }
        }
      }
    };
    return (
      <WizTableForm {...entityDataConfig} {...tableFormProps} />
    )
  }

  /**上一步*/
  _prev = () => {
    this.props.prevFunc && this.props.prevFunc()
  }
  /**保存并进入下一步*/
  _saveAndNext = () => {
    let {applyInfo,type} = this.state
    if (applyInfo.plans && applyInfo.plans.length && applyInfo.plans.length > 0) {
      if (type === 'create') {
        type = 'update'
      }
    }
    let plans = applyInfo.plans
    this.setState({status: 1}, () => {
      if (type === 'update') {
        this._updatePlans(plans)
      } else {
        this._createPlans(plans)
      }
    })
  }
  /**保存并返回*/
  _saveAndBack = () => {
    let {replaceClose}=this.props
    let {applyInfo} = this.state
    let plans = applyInfo.plans
    this.setState({status: 2}, () => {
      if (this.state.type === 'update') {
        this._updatePlans(plans)
        this.props.backFunc = replaceClose?replaceClose():this.jumpPage('replace', this.pathname)
      } else {
        this._createPlans(plans)
        this.props.backFunc = replaceClose?replaceClose():this.jumpPage('replace', this.pathname)
      }
    })
  }
  /**重置*/
  _onReset = () => {
    let {plans} = this.props
    let {applyInfo,planType} = this.state
    plans && plans.length && plans.forEach(plan => {
      plan.type = planType
    })
    applyInfo.plans = plans

    this.setState({applyInfo: applyInfo, date: new Date()})
  }

  _render() {
    let {applyPlanLoading,applyLoading} = this.props
    let {applyInfo,applyPlanFooter,planType} = this.state
    this.setState({applyInfo: applyInfo})
    const columns = createColumn(this)
    let displayVar = "show"
    let footerBut = {}
    let buttonVar = {}
    if (planType === 1 && applyPlanFooter === 1) {
      buttonVar = <div className="table-row">
        <WizButton type="primary" onClick={this._createApplyPlan.bind(this)} style={{marginRight:20}}>+新增计划安排</WizButton>
        <WizButton type="primary" onClick={this._syncUpdatePlan.bind(this)}>同步班级数据</WizButton>
      </div>
    } else {
      buttonVar = <div className="table-row">
        <WizButton type="primary" onClick={this._createApplyPlan.bind(this)} style={{marginRight:20}}>+新增计划安排</WizButton>
      </div>
    }
    if (applyPlanFooter === 1) {
      displayVar = "none"
      footerBut =
      <WizRow className="apply-button-row">
        <WizCol>
          <WizButton title='保存并返回' onClick={this._saveAndBack}>保存并返回</WizButton>
          <WizButton title='重置' type='reset' onClick={this._onReset}>重置</WizButton>
        </WizCol>
      </WizRow>

    } else {
      displayVar = "show"
      footerBut =
      <WizRow className="apply-button-row">
        <WizCol>
          <WizButton title='上一步' onClick={this._prev}>上一步</WizButton>
          <WizButton title='保存并进入下一步' type='primary' onClick={this._saveAndNext}>保存并进入下一步</WizButton>
          <WizButton title='保存并返回' onClick={this._saveAndBack}>保存并返回</WizButton>
          <WizButton title='重置' type='reset' onClick={this._onReset}>重置</WizButton>
        </WizCol>
      </WizRow>
    }
    return (
      <div className="table-div">
        <WizSpin tip={"加载中"} spinning={applyPlanLoading && applyLoading}>
          <div className="table-row" style={{display:displayVar}}>
            <WizRow>
              <WizCol span={3}>
                <WizIcon type="question-circle"/>
                <span className="header-icon-font"> <b>设置说明</b>  </span>
              </WizCol>
              <WizCol span={21}>
                <div className="header-font">根据报名基本信息中的报名计划安排类型，可添加不同的计划安排内容</div>
              </WizCol>
            </WizRow>
          </div>
          {buttonVar}
          <div className="table-row">
            <WizTable columns={columns} dataSource={applyInfo.plans}/>
          </div>
          {footerBut}
          {this.showNormalModal()}
          {this.showEntityModal()}
        </WizSpin>
      </div>
    )
  }

}

const mapStateToProps = (state, ownProps) => {
  const {apply, applyPlan, classManagement} = state
  let {applyId} = ownProps
  const applyInfo = modelUtils.getModelEntity(apply, "getApplyInfo_" + applyId);
  const planList = modelUtils.getModelEntity(apply, "planListByPage");
  const updatePlan = modelUtils.getModelEntity(applyPlan, 'updatePlan');
  const createPlans = modelUtils.getModelEntity(apply, 'createApplyPlans_' + applyId);
  const updatePlans = modelUtils.getModelEntity(apply, 'updateApplyPlans_' + applyId);
  const enablePlan = modelUtils.getModelEntity(applyPlan, 'enablePlan');
  const classInfo = modelUtils.getModelEntity(classManagement, "classManagement@getClassById");
  const syncClassInfo = modelUtils.getModelEntity(apply, 'syncUpdatePlan');
  const load = modelUtils.getLoadingState(state, ['apply', 'applyPlan', 'classManagement']);
  return {
    applyInfo,
    planList,
    updatePlan,
    createPlans,
    updatePlans,
    enablePlan,
    classInfo,
    syncClassInfo,
    ...load
  }
}

export default connect(mapStateToProps)(ApplyPlanDetail)
